import React, { useMemo, useState, useEffect } from 'react';
import { Button, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';

import AlertComponent from '../../../../../components/Alert';
import VirtualSelect from '../../../../../components/Select/Virtual';
import Wall from '../Wall';

import { servicesCountriesUpdate } from '../../../../../services/endpoints/services';
import { getErrorMessage } from '../../../../../utils/helper';

const Countries = ({ countries, loading }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [localList, setLocalList] = useState(countries);
  const [selected, setSelected] = useState([]);
  const [error, setError] = useState(null);

  const selectedCountries = useMemo(() => localList?.filter((item) => item.selected)?.map((item) => item.country_code), [localList]);

  const selectList = useMemo(
    () => [...localList]
      ?.sort((a, b) => b.selected - a.selected)
      ?.map((item) => ({
        id: item.country_code,
        title: item.country_name,
      })),
    [localList],
  );

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      await servicesCountriesUpdate(selected);
      setLocalList((prev) => prev.map((item) => {
        const isSelected = selected?.includes(item.country_code);
        return { ...item, selected: isSelected };
      }));
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (countries?.length) {
      setLocalList(countries);
    }
  }, [countries]);

  return (
    <div className="mb-15">
      <Wall rounded>
        <div>
          {isLoading || loading ? <div className="modal-loader-small" /> : null}
          {error ? <AlertComponent text={error} /> : null}
          <ControlLabel>Blocked countries</ControlLabel>
          <form onSubmit={onSubmit} className="services-hide__header-row">
            <VirtualSelect
              toggleBtnTitle="Choose country"
              optionsTitle="countries"
              onChange={(options) => setSelected(options)}
              options={selectList}
              selectedOptions={selectedCountries}
              showLoader={false}
              toggleComponent={({ values }) => (
                <>
                  {values?.length === 0 ? (
                    <span style={{ color: '#999' }}>Choose country</span>
                  ) : (
                    <>
                      Countries
                      {' '}
                      <span className="options-count">{`(${values.length})`}</span>
                    </>
                  )}
                </>
              )}
              needUpdateSelected
            />
            <Button disabled={isLoading || loading} type="submit" bsStyle="primary">
              Save
            </Button>
          </form>
        </div>
      </Wall>
    </div>
  );
};

Countries.propTypes = {
  countries: PropTypes.array,
  loading: PropTypes.bool,
};

export default Countries;
